/**
 * Aspect — Snapshot idempotency gate (pure logic, no engine imports)
 * --------------------------------------------------------------
 * Server snapshots carry a monotonic `version` and a per-process `syncId`
 * epoch. The gate ensures a snapshot applies AT MOST once and never out of
 * order: within one epoch, only strictly newer versions pass. A different
 * epoch (server restart) always passes. Legacy snapshots without a version
 * always pass (backward compatible).
 */

export class SnapshotGate {
  constructor() {
    this.appliedVersion = -Infinity;
    this.epoch = null;
  }

  /** True when the snapshot is stale (same epoch, version <= last applied). */
  isStale(state) {
    const v = Number(state?.version);
    if (!Number.isFinite(v)) return false;
    const epoch = state?.syncId ?? null;
    if (epoch !== this.epoch) return false;
    return v <= this.appliedVersion;
  }

  /** Record a successfully applied snapshot. */
  markApplied(state) {
    const v = Number(state?.version);
    if (!Number.isFinite(v)) return;
    this.epoch = state?.syncId ?? null;
    this.appliedVersion = v;
  }

  /** Force the next snapshot through (reconnect / local desync). */
  reset() {
    this.appliedVersion = -Infinity;
  }
}

export default SnapshotGate;
